import React from 'react';
import { cn } from '@/lib/utils';

interface MobileEmptyStateProps {
    icon: React.ReactNode;
    title: string;
    description?: string;
    action?: React.ReactNode;
    className?: string;
}

export function MobileEmptyState({
    icon,
    title,
    description,
    action,
    className
}: MobileEmptyStateProps) {
    return (
        <div className={cn('mobile-empty-state', className)}>
            <div className="text-muted-foreground mb-4">
                {icon}
            </div>
            <h3 className="text-lg font-semibold mb-1">{title}</h3>
            {description && (
                <p className="text-sm text-muted-foreground mb-4">
                    {description}
                </p>
            )}
            {action}
        </div>
    );
}
